import { render, staticRenderFns } from "./QualificationLevelList.vue?vue&type=template&id=08c980c9&scoped=true"
import script from "./QualificationLevelList.vue?vue&type=script&lang=js"
export * from "./QualificationLevelList.vue?vue&type=script&lang=js"
import style0 from "./QualificationLevelList.vue?vue&type=style&index=0&id=08c980c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c980c9",
  null
  
)

export default component.exports